<div class="screen-element menu-showcase">
	<div class="title"><text-widget [text]="getTranslator().tr(title)" [color]="'white'"></text-widget></div>

	<div class="items">
		<div *ngFor="let t of items">
			<text-widget [text]="getTranslator().tr(t.value)" [boxed]="true" [color]="'white'"></text-widget>
		</div>
	</div>
	<div class="text">
		<div *ngFor="let t of text">
			<text-widget [text]="getTranslator().tr(t)" [color]="'white'"></text-widget>
		</div>
	</div>
</div>